<template>
  <el-dialog
      :visible.sync="visible"
      title="图片查看"
      :close-on-click-modal="true"
      :close-on-press-escape="false"
      width="90%"
  >
    <div style="display: flex;flex-wrap: wrap;">
      <div style="width:100px;height:120px;margin-right: 20px;position: relative;padding-top: 20px;"
           v-for="(item,index) in dataList"
           :key="index">
        <el-image fit="contain" :src="item" style="width:100px;height:100px;"
                  :preview-src-list="dataList"/>
        <el-icon class="el-icon-close" v-if="showRemove&&$hasPermission('erp:store:removeImg')"
                 style="position: absolute;top: 0;right: 0;font-weight: 500;font-size: 18px;cursor: pointer;z-index: 999"
                 @click.native="removeImg(item)"></el-icon>
      </div>
    </div>

    <template #footer>
      <tool-tip style="width: 200px;">点击图片可查看原图</tool-tip>
    </template>
  </el-dialog>
</template>

<script>

export default {
  name: 'ImagePreviewer',
  props: {
    showRemove: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      dataList: [],
      sourceData: null,//透传过来的数据,移除图片回调的时候会传递给父组件
    }
  },
  methods: {
    init (dataList) {
      this.dataList = dataList
      this.visible = true
    },
    async removeImg (item) {
      await this.$confirm('是否移除该图片?', '操作提示')
      this.dataList.splice(this.dataList.indexOf(item), 1)
      this.$emit('remove', item, this.sourceData)
      if (this.dataList.length === 0) {
        this.visible = false
      }
    }
  }
}
</script>

<style scoped>

</style>
